<script setup>
import CustomFieldValue from "../customFields/CustomFieldValue.vue";
import startupsService from "@/services/startups.service";
import trackersCompaniesService from "../../services/trackers-companies.service";
import {ref, provide, watch, inject} from "vue";

const props = defineProps(['columnData', 'rowId', 'addData']);
const emit = defineEmits(['diligenceFieldChanged', 'customValueChanged']);

const customFieldValue = ref(null);
const customValueChangedData = inject('customValueChangedData');
const fieldData = ref(null);
const valueData = ref(null);

watch(() => props.columnData.field,  value => {
    fieldData.value = value;
}, {immediate: true});

watch(() => props.columnData.value,  value => {
    valueData.value = value;
}, {immediate: true});

watch(customValueChangedData, (value) => {
    if (value.rowId === props.rowId) {
        let [, fieldId] = value.columnName.split('_');

        if (parseInt(fieldId) === props.columnData.field.depends_on) {
            updateFieldOptions()
        }
    }
});

function valueChanged(newValue) {
    if (props.columnData.field.main_type === 'tracker_diligence') {
        emit('diligenceFieldChanged');
    }

    valueData.value = newValue;
    emit('customValueChanged');
}
function saveCustomValue(fieldId, newValue) {
    if (props.columnData.field.main_type === 'tracker_diligence') {
        return trackersCompaniesService.saveDiligenceValues(props.addData.trackerId, props.rowId, fieldId, {newValue});
    } else {
        return startupsService.saveCustomValue(props.rowId, fieldId, {newValue});
    }
}

function saveCustomFile(fieldId, data) {
    if (props.columnData.field.main_type === 'tracker_diligence') {
        return trackersCompaniesService.saveDiligenceFiles(props.addData.trackerId, props.rowId, fieldId, data);
    } else {
        return startupsService.saveCustomFiles(props.rowId, fieldId, data);
    }
}

async function updateFieldOptions() {
    const {data} = await startupsService.getCustomFieldAvailableOptions(props.rowId, fieldData.value.id);

    fieldData.value.options = data;

    if (valueData.value.options.length && (!fieldData.value.options.length || !data.find(option => option.id === valueData.value.options[0].id))) {
        valueData.value = {
            text: "",
            options: [],
            links: [],
            files: [],
        };

        await saveCustomValue(fieldData.value.id, valueData.value);
    }
}

provide('saveCustomValue', saveCustomValue);
provide('saveCustomFile', saveCustomFile);

</script>

<template>
    <CustomFieldValue
        ref="customFieldValue"
        :field="fieldData"
        :editable="columnData.field.can_edit"
        :init-value="valueData"
        :from-table="true"
        @valueChanged="valueChanged"
    />
</template>

<style scoped>

</style>
